export const SET_CURRENT_VIDEO_ROOM = "SET_CURRENT_VIDEO_ROOM"
export const SET_CURRENT_VIDEO_MESSAGES = "SET_CURRENT_VIDEO_MESSAGES"
